module.exports = __webpack_public_path__ + "img/rslogo.8e6bf103.jpg";